import React, {useEffect} from "react";
import styled from "styled-components";
import {useDispatch, useSelector} from "react-redux";
import {updateReceivableInfoList} from "redux/slices/sales/salesSlice";

import "utils/date";
import {getCommaNumber} from "utils/format";

import Observer from "components/ui/Observer";



/**
 * [누적 미수금 조회 목록]
 */

export const DetailList = (props) => {
	const dispatch = useDispatch();

	const {
		searchPartner,
		searchBranch,
		searchDate,
		dataList,
		page,
		pageState
	} = useSelector(state => state.sales.receivableInfo);

	useEffect(() => {
		if(pageState != undefined) {
			dispatch(updateReceivableInfoList(false));
		}
	}, [searchPartner, searchBranch, searchDate]);

	const eventHandler = {
		update : function() {
			dispatch(updateReceivableInfoList(true));
		}
	};

	const getReceivableList = () => {
		let li = (dataList || []).map((item, index) => {
			const orderDatetime = new Date(item.occurDatetime).getFormattedDatetime();
			return (
				<li key={item.seqOrderInfo || index}>
					<h5><span>{orderDatetime}</span><span data-clarity-mask="True">{item.userName}</span></h5>
					<h4>{(item.orderName || "-").recoverTag()}</h4>
					<ul>
						<li><div>판매금액</div><div>{getCommaNumber(item.salesPrice)}원</div></li>
						<li><div>결제금액</div><div><b>{getCommaNumber(item.paymentPrice)}원</b></div></li>
						<li><div>미수금</div><div className="red"><b>{getCommaNumber(item.receivables)}원</b></div></li>
					</ul>
				</li>
			)
		});
		if(!li.length && pageState == false) {
			li = <li className="empty">조회된 내역이 없습니다.</li>
		}
		return (<ul className="color">{li}</ul>);
	};

	return (
		<Wrapper>
			{getReceivableList()}
			<Observer isActive={pageState} isLoading={true} onVisible={eventHandler.update} />
		</Wrapper>
	)
};

const Wrapper = styled.div`
&						{padding:0 25px}
& > ul > li				{padding:25px 0}
& > ul > li + li		{border-top:1px solid var(--lightBorder)}

ul						{width:100%}
li li					{display:flex; align-items:center; justify-content:space-between}
li li b					{font-weight:600}
li li div:first-child	{font-size:var(--14px); color:var(--gray50)}
li li div + div			{text-align:right}
li.empty				{padding:20px 0; border:none; text-align:center; opacity:0.66}

h4						{margin:5px 0 10px; font-size:var(--18px); font-weight:500}
h5						{font-size:var(--13px); font-weight:normal; color:var(--gray40)}
h5 span + span:before	{content:"|"; margin:0 0.5em; color:var(--gray); opacity:0.5}
li .red					{font-weight:600}
`;

export default DetailList;